import React, { Component } from 'react'
import { Col, Container, Row, Form } from 'react-bootstrap';
import { Button } from "@mui/material";
import Select from '../../Components/PCSelect';
import WeekRangeSelect from '../../Components/WeekRangeSelect';
import axios from "axios";

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Detail from './Detail'
import Summary from './Summary'
import { getISOWeek, sumMoney, round2, parseMoney, isAccPayLine, getWeekDetails, formatDisplayWeek, weekInDateWindow, windowCoversAnyWeek, normalizeWeekCode } from './../../helper';
import PageHeader from '../../Pages/admin/shared/PageHeader';
import PrintButton from '../../Pages/admin/shared/PrintButton';
import FilterCard from '../../Pages/admin/shared/FilterCard';
import { ownLimit, limitOptions } from '../../helper/identity';

const SCREEN = '/report/account-balance';
// import ByWeek from './ByWeek'

class AccountBalance extends Component {
    constructor(props) {
        super(props);
        this.state = {

            Account_Name: "",
            // Default the filter to the current week so the dropdown opens on it
            // instead of the oldest listed week. The report still waits for "View".
            From_Week: getWeekDetails().weekId,
            To_Week: getWeekDetails().weekId,
            reportView: "detail",

            AccountList: [],
            AllAccountData: [],
            shopPaymentDays: [],


            TotalSummary: [],
            showReport: false,
            // Summary sweeps every account one at a time, so surface progress
            // rather than leaving the user on a blank screen.
            summaryBusy: false,
            summaryDone: 0,
            summaryTotal: 0,

            ReportDetails: {},
            PC_GRP_ATT: localStorage.getItem('PC_GRP_ATT'),
            isAccountDisable: false
        }
    }

    componentDidMount() {
        this.getAllPayaccount()
    }



    async getAllPayaccount() {
        const getAllPayAccounts = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/PCGetAllPayAccount.php`);
        let deviceData = getAllPayAccounts.data
        /* Only the user's own account, selected and locked — every account for an admin (user,
         * 2026-11-02). */
        const limit = ownLimit('account', SCREEN);
        const ownIds = limit ? new Set(limit.map(e => e.id)) : null;
        const AllAccountData = (deviceData.success === 1 ? deviceData.data : [])
            .filter(a => !ownIds || ownIds.has(String(a.ACCOUNT_ID)));
        const AccountList = limitOptions(
            AllAccountData.map(a => ({ label: a.ACCOUNT_TITLE, value: a.ACCOUNT_ID, type: "account" })),
            limit, { type: "account" }
        );
        const locked = !!limit && AccountList.length === 1;
        this.setState({ AccountList, AllAccountData, isAccountDisable: locked, Account_Name: locked ? AccountList[0] : "" })
    }

    handleChange(fieldName, evnt) {
        let targetValue = ""
        switch (fieldName) {
            case 'Account_Name':
                targetValue = evnt
                break;

            default:
                targetValue = evnt.target.value
                break;
        }

        // Changing the view (or the account) invalidates whatever is on screen — clear it
        // so Detail figures are never read under a Summary heading, or vice versa.
        if (fieldName === 'reportView' || fieldName === 'Account_Name') {
            this.setState({ [fieldName]: targetValue, showReport: false, TotalSummary: [], ReportDetails: {} })
            return
        }

        this.setState({ [fieldName]: targetValue })
    }

    // Detail reports on the single selected account; Summary rolls up every account the
    // user may see. Both funnel through buildReportForAccount() below, so the two views
    // can never disagree on a figure.
    async handleViewReport() {
        const { reportView, AllAccountData } = this.state;

        if (reportView !== 'summary') {
            if (!this.state.Account_Name || !this.state.Account_Name.value) {
                this.props.toggleSnackBar && this.props.toggleSnackBar(true, 'Error', 'Please select an account first', 'error');
                return;
            }
            this.props.toggleLoader && this.props.toggleLoader(true);
            try {
                const setData = await this.buildReportForAccount(this.state.Account_Name.value);
                this.setState({ showReport: true, ReportDetails: setData });
            } finally {
                this.props.toggleLoader && this.props.toggleLoader(false);
            }
            return;
        }

        // AllAccountData holds only the user's own accounts (every account for an admin), so Summary
        // never shows another account's balances.
        const scoped = AllAccountData || [];

        this.setState({ summaryBusy: true, summaryDone: 0, summaryTotal: scoped.length, TotalSummary: [] });
        this.props.toggleLoader && this.props.toggleLoader(true);

        const rows = [];
        // The not-approved weeks are system-wide, so every account returns the same list.
        let unapprovedWeeks = [];
        for (let i = 0; i < scoped.length; i++) {
            const acc = scoped[i];
            try {
                const data = await this.buildReportForAccount(acc.ACCOUNT_ID);
                if (data && Array.isArray(data.unapprovedWeeks)) unapprovedWeeks = data.unapprovedWeeks;
                rows.push(this.toSummaryRow(acc.ACCOUNT_TITLE, data));
            } catch (err) {
                // One account failing must not blank the whole report, and must not
                // read as a genuine 0.00 either - Summary.js renders these as em-dashes.
                rows.push({ AccountTitle: acc.ACCOUNT_TITLE, failed: true });
            }
            this.setState({ summaryDone: i + 1 });
        }

        this.props.toggleLoader && this.props.toggleLoader(false);
        this.setState({ summaryBusy: false, showReport: true, TotalSummary: rows, summaryUnapproved: unapprovedWeeks });
    }

    /* Adds a placeholder row for each week in the range that holds not-approved records but has
       no P&L row — its weekly sale is unapproved, so no share was settled for it (T1.35, user's
       choice). Placeholders carry no figures (Detail.js prints a dash per shop) and are added
       AFTER every total has been computed, so no total or balance changes. `allWeeks` is the
       full week list of the range, which supplies each week's labels. */
    withUnapprovedWeekRows(rows, allWeeks, unapprovedWeeks) {
        const have = new Set((rows || []).map(r => normalizeWeekCode(r.weekNum)));
        const extra = [];
        for (const u of (unapprovedWeeks || [])) {
            const code = normalizeWeekCode(u.WEEK);
            if (have.has(code)) continue;
            const week = (allWeeks || []).find(w => normalizeWeekCode(w.weekNum) === code);
            if (!week) continue;
            extra.push({ WeekOut: week.WeekOut, weekNum: week.weekNum, joinPnLWeekDate: week.joinPnLWeekDate, PnL: [], noApprovedSale: true });
            have.add(code);
        }
        if (extra.length === 0) return rows;
        return [...rows, ...extra].sort((a, b) => a.joinPnLWeekDate - b.joinPnLWeekDate);
    }

    // Collapses one computed report into a summary row.
    //
    // Every figure is produced by the SAME expression Detail.js prints, character for
    // character (Detail.js footer, ~line 304-320), including two details that look cosmetic but
    // are not: Net rounds Card to 2dp *before* subtracting, and it uses .toFixed(2)
    // rather than round2(). totalPnL is an unrounded percentage share
    // ((weeklySalePnL / 100) * Percentage), so it carries fractional pence — with a
    // different rounding order Summary and Detail would disagree by a penny on the same
    // account. If the Detail footer ever changes, change this with it.
    toSummaryRow(title, d) {
        const r = d || {};
        const pnl = +r.totalPnL || 0;
        const pba = +r.pbaTotal || 0;
        const pbs = +r.pbsTotal || 0;
        const card = +r.totalCardSum || 0;
        const fb = +r.FB || 0;

        const FBtxt = (r.FB === undefined || r.FB === null || r.FB === "") ? "0.00" : String(r.FB);
        const PnLtxt = pnl.toFixed(2);
        const Cardtxt = card.toFixed(2);
        const ShopPaytxt = pbs.toFixed(2);
        const AccountPaytxt = pba.toFixed(2);
        const Nettxt = parseFloat((pnl + pba + fb) - parseFloat(card.toFixed(2)) - pbs).toFixed(2);

        return {
            AccountTitle: title,
            FBtxt, PnLtxt, Cardtxt, ShopPaytxt, AccountPaytxt, Nettxt,
            // Numeric mirrors parsed back from the displayed strings, so the Total row can
            // never disagree with the column of figures printed above it.
            FB: +FBtxt, PnL: +PnLtxt, Card: +Cardtxt,
            ShopPay: +ShopPaytxt, AccountPay: +AccountPaytxt, Net: +Nettxt
        };
    }

    async buildReportForAccount(accountId) {
        let filterPayAccDet = this.state.AllAccountData.filter(x => String(x.ACCOUNT_ID) === String(accountId));
        let parsifyShopCard = []
        let parsifyShopPart = []
        let openBalance = 0;

        if (filterPayAccDet.length > 0) {
            parsifyShopCard = JSON.parse(filterPayAccDet[0].ShopCardDetail)
            parsifyShopPart = JSON.parse(filterPayAccDet[0].ShopPartnerDetail)
            // OPENING_BALANCE is varchar, so it holds whatever was typed — one live
            // account has "-83,983.68". `+openBalance` on that is NaN, and FB below
            // then renders the literal string "NaN". parseMoney() tolerates it.
            openBalance = parseMoney(filterPayAccDet[0].OPENING_BALANCE)
        }

        let shopCardIDs = "";
        let shopPartIDs = "";

        // Build plain comma-separated integer IDs (e.g. "4,40"). The report endpoints sanitize these
        // with intval(), so quoted values like '4' become 0 and get rejected ("No valid shop selected").
        for (let i = 0; i < parsifyShopCard.length; i++) {
            const eachShops = parsifyShopCard[i];
            shopCardIDs += `${eachShops.ShopName.value},`
        }
        shopCardIDs = shopCardIDs.slice(0, -1)

        let shopDataList = [];
        for (let i = 0; i < parsifyShopPart.length; i++) {
            const eachShops = parsifyShopPart[i];
            /* shopPartIDs stays the FULL list — it is only the SQL scope, and the endpoints are
               filtered per week anyway. */
            shopPartIDs += `${eachShops.ShopName.value},`

            /* But a shop only earns a COLUMN if its window covers a week on screen. Without this
               an ended partnership kept its column for ever: Enfield ran 2022-08-01..2024-08-04
               yet still appeared in an August 2026 report. 86 such rows exist across 22 accounts,
               so this was every account, not one. */
            if (windowCoversAnyWeek(eachShops.FromDate, eachShops.ToDate,
                                    this.state.From_Week, this.state.To_Week)) {
                shopDataList.push(eachShops);
            }
        }

        shopPartIDs = shopPartIDs.slice(0, -1)
        let formData = {
            Account_ID: accountId,
            Account_Name: shopPartIDs,
            Card_Shops: shopCardIDs,
            From_Week: this.state.From_Week,
            To_Week: this.state.To_Week,
            reportView: this.state.reportView
        }

        const getShops = await axios.post(`${process.env.REACT_APP_BASE_URL}services/report/accountBalance.php`, formData);
        const getPreShops = await axios.post(`${process.env.REACT_APP_BASE_URL}services/report/forwardBalance.php`, formData);

        /* Open_Date is the account's OPENING_DATE, and it is what stops the two P&L endpoints
           counting weeks the opening balance already covers. The opening balance is the position
           AS AT that date, so only activity from the day after it may be added on top — without
           this, BALANCE B/F was opening balance + every week ever (live: account 7 had £1,355.00
           from 2025 added on top of a balance that already included it).

           It is OPTIONAL on the endpoints by design: the standalone Profit & Loss report sends no
           Open_Date and its SQL is then unchanged, verified byte-identical. */
        let formDataB = {
            Shop_Name: shopPartIDs,
            From_Week: this.state.From_Week,
            To_Week: this.state.To_Week,
            reportView: this.state.reportView,
            Open_Date: (filterPayAccDet.length > 0 ? (filterPayAccDet[0].OPENING_DATE || '') : '')
        }

        const getShopsPnL = await axios.post(`${process.env.REACT_APP_BASE_URL}services/report/profitAndLoss.php`, formDataB);
        const getPreShopsPnL = await axios.post(`${process.env.REACT_APP_BASE_URL}services/report/previousPnL.php`, formDataB);

        let getShopsPnLData = getShopsPnL.data;
        let getPreShopsPnLData = getPreShopsPnL.data;

        let getWSDet_stmt_data = getShopsPnLData.getWSDet_stmt_data || [];
        let getShopExp_stmt_data = getShopsPnLData.getShopExp_stmt_data || [];
        let getAccPay_stmt_data = getShopsPnLData.getAccPay_stmt_data || [];
        let getShopPay_stmt_data = getShopsPnLData.getShopPay_stmt_data || [];
        let getShopPayAct_stmt_data = getShopsPnLData.getShopPayAct_stmt_data || [];
        let getShopPayment_stmt_data = getShopsPnLData.getShopPayment_stmt_data || [];

        let getPreWSDet_stmt_data = getPreShopsPnLData.getWSDet_stmt_data || [];
        let getPreShopExp_stmt_data = getPreShopsPnLData.getShopExp_stmt_data || [];
        let getPreAccPay_stmt_data = getPreShopsPnLData.getAccPay_stmt_data || [];
        let getPreShopPay_stmt_data = getPreShopsPnLData.getShopPay_stmt_data || [];
        let getPreShopPayAct_stmt_data = getPreShopsPnLData.getShopPayAct_stmt_data || [];
        let getPreShopPayment_stmt_data = getPreShopsPnLData.getShopPayment_stmt_data || [];

        let shopData = getShops.data
        let shopPreData = getPreShops.data

        let setData = {}
        // The account's own name — Detail.js shows it as "On Behalf Acc" on rows another account paid for it.
        setData['accountTitle'] = filterPayAccDet.length > 0 ? (filterPayAccDet[0].ACCOUNT_TITLE || '') : '';
        let totalFilledWeek = []
        let totalPreFilledWeek = []

        if (getShopsPnL) {
            for (let i = 0; i < parsifyShopPart.length; i++) {
                const repData = parsifyShopPart[i];

                for (let j = 0; j < getWSDet_stmt_data.length; j++) {
                    const eachData = getWSDet_stmt_data[j];
                    if (repData.ShopName.value === eachData.PC_WS_SHOPID) {
                        let PnLWeekDate = eachData.PC_WS_WEEK.split('-');
                        PnLWeekDate[1] = PnLWeekDate[1].replace("W", "");
                        let joinPnLWeekDate = parseInt(PnLWeekDate.join(""));

                        let extraExt = 0;

                        /* Window holds DATES since migration 2026_10_14. A week counts when its
                         * MONDAY falls inside it — helper.js weekInDateWindow(). */
                        if (weekInDateWindow(eachData.PC_WS_WEEK, repData.FromDate, repData.ToDate) && (eachData.PC_WS_SHOPID === repData.ShopName.value)) {

                            for (let k = 0; k < getShopExp_stmt_data.length; k++) {
                                const shpExt_Exp = getShopExp_stmt_data[k];
                                // Match on shop AND week: profitAndLoss.php returns one charge row per
                                // (shop, week) with the rate effective for that week. Without the week
                                // filter every week re-adds every other week's charges (over-counted N×).
                                if (repData.ShopName.value === shpExt_Exp.PC_SP_ID && shpExt_Exp.PC_WS_WEEK === eachData.PC_WS_WEEK) {
                                    extraExt += +shpExt_Exp.SP_RENT_CHARGES + +shpExt_Exp.SP_KN_CHARGES + +shpExt_Exp.SP_NDR_CHARGES;
                                }
                            }

                            for (let k = 0; k < getAccPay_stmt_data.length; k++) {
                                const weekDel = getAccPay_stmt_data[k];
                                if (repData.ShopName.value === weekDel.SHOP_ID && weekDel.TR_WEEK === eachData.PC_WS_WEEK) {
                                    extraExt += +weekDel.TR_AMT;
                                }
                            }

                            for (let k = 0; k < getShopPay_stmt_data.length; k++) {
                                const accPay = getShopPay_stmt_data[k];
                                if (repData.ShopName.value === accPay.SHOP_ID && accPay.TR_WEEK === eachData.PC_WS_WEEK) {
                                    extraExt += +accPay.TR_AMT;
                                }
                            }

                            for (let k = 0; k < getShopPayAct_stmt_data.length; k++) {
                                const shopPayAct = getShopPayAct_stmt_data[k];
                                if (repData.ShopName.value === shopPayAct.TR_FROM && shopPayAct.TR_WEEK === eachData.PC_WS_WEEK) {
                                    extraExt += +shopPayAct.TR_AMT;
                                }
                            }

                            for (let k = 0; k < getShopPayment_stmt_data.length; k++) {
                                const shopPay = getShopPayment_stmt_data[k];
                                if (repData.ShopName.value === shopPay.SHOP_ID && shopPay.TR_WEEK === eachData.PC_WS_WEEK) {
                                    extraExt += +shopPay.TR_AMT;
                                }
                            }

                            // Takings MINUS expenses — profit is positive, a loss is negative.
                            // Do not reverse this. The authority is legacy
                            // SP_MS_FMS_RptAccountTransactions_Balance_Query (script.sql:3310):
                            //   ((WeeklyCash + WeeklyCard) - WeeklyExpense) / 100 * Percentage
                            // and it is the same direction as ProfitAndLoss/index.js:385 and
                            // WeeklySale.js returnProfitAndLoss(). Until 2026-10-08 this read
                            // `extraExt - (sales)`, so every profitable week showed as negative.
                            let pNlMainData = (+eachData.WS_Cash + +eachData.WS_Card + +eachData.WS_Other) - extraExt
                            totalFilledWeek.push({ joinPnLWeekDate, weeklySalePnL: pNlMainData, shopID: eachData.PC_WS_SHOPID, totalPerc: repData.Percentage });
                        }
                    }
                }

            }
        }

        if (getPreShopsPnL) {
            for (let i = 0; i < parsifyShopPart.length; i++) {
                const repData = parsifyShopPart[i];
                if (getPreWSDet_stmt_data) {
                    for (let j = 0; j < getPreWSDet_stmt_data.length; j++) {
                        const eachData = getPreWSDet_stmt_data[j];
                        if (repData.ShopName.value === eachData.PC_WS_SHOPID) {
                            let PnLWeekDate = eachData.PC_WS_WEEK.split('-');
                            PnLWeekDate[1] = PnLWeekDate[1].replace("W", "");
                            let joinPnLWeekDate = parseInt(PnLWeekDate.join(""));

                            let extraExt = 0;

                            /* Window holds DATES since migration 2026_10_14. A week counts when its
                             * MONDAY falls inside it — helper.js weekInDateWindow(). */
                            if (weekInDateWindow(eachData.PC_WS_WEEK, repData.FromDate, repData.ToDate) && (eachData.PC_WS_SHOPID === repData.ShopName.value)) {

                                for (let k = 0; k < getPreShopExp_stmt_data.length; k++) {
                                    const shpExt_Exp = getPreShopExp_stmt_data[k];
                                    /* Shop AND week, same as the in-range loop above.
                                       previousPnL.php now returns one charge row per (shop, week)
                                       with that week's effective rate; before 2026-10-21 it
                                       returned one row per shop holding TODAY's rate, with
                                       PC_SP_ID as an INT, so `===` never matched and rent / K&N /
                                       NDR were missing from BALANCE B/F altogether. */
                                    if (String(repData.ShopName.value) === String(shpExt_Exp.PC_SP_ID) && shpExt_Exp.PC_WS_WEEK === eachData.PC_WS_WEEK) {
                                        extraExt += +shpExt_Exp.SP_RENT_CHARGES + +shpExt_Exp.SP_KN_CHARGES + +shpExt_Exp.SP_NDR_CHARGES;
                                    }
                                }

                                for (let k = 0; k < getPreAccPay_stmt_data.length; k++) {
                                    const weekDel = getPreAccPay_stmt_data[k];
                                    if (repData.ShopName.value === weekDel.SHOP_ID && weekDel.TR_WEEK === eachData.PC_WS_WEEK) {
                                        extraExt += +weekDel.TR_AMT;
                                    }
                                }

                                for (let k = 0; k < getPreShopPay_stmt_data.length; k++) {
                                    const accPay = getPreShopPay_stmt_data[k];
                                    if (repData.ShopName.value === accPay.SHOP_ID && accPay.TR_WEEK === eachData.PC_WS_WEEK) {
                                        extraExt += +accPay.TR_AMT;
                                    }
                                }

                                for (let k = 0; k < getPreShopPayAct_stmt_data.length; k++) {
                                    const shopPayAct = getPreShopPayAct_stmt_data[k];
                                    if (repData.ShopName.value === shopPayAct.TR_FROM && shopPayAct.TR_WEEK === eachData.PC_WS_WEEK) {
                                        extraExt += +shopPayAct.TR_AMT;
                                    }
                                }

                                for (let k = 0; k < getPreShopPayment_stmt_data.length; k++) {
                                    const shopPay = getPreShopPayment_stmt_data[k];
                                    if (repData.ShopName.value === shopPay.SHOP_ID && shopPay.TR_WEEK === eachData.PC_WS_WEEK) {
                                        extraExt += +shopPay.TR_AMT;
                                    }
                                }

                                // Same direction as the in-range copy above — see the comment there.
                                // This one feeds BALANCE B/F via totalPnLPre.
                                let pNlMainData = (+eachData.WS_Cash + +eachData.WS_Card + +eachData.WS_Other) - extraExt
                                totalPreFilledWeek.push({ joinPnLWeekDate, weeklySalePnL: pNlMainData, shopID: eachData.PC_WS_SHOPID, totalPerc: repData.Percentage });
                            }
                        }

                    }
                }
            }
        }

        if (shopData.success === 1 && shopData.message === "Record Available.") {
            // Weeks in the range holding not-approved records, system-wide — a marker only (T1.35).
            setData['unapprovedWeeks'] = shopData.unapprovedWeeks || [];
            let reportDataB = shopData.dataB;
            let reportDataC = shopData.dataC;
            let reportDataE = shopData.dataE;
            let reportDataF = shopData.dataF;
            let reportDataH = shopData.dataH;

            setData['totalFilledWeek'] = totalFilledWeek
            // Detaill

            let filterShopList = []
            for (let i = 0; i < shopDataList.length; i++) {
                const shop = shopDataList[i];
                let filterShop = filterShopList.filter(x => x.ShopName.value === shop.ShopName.value)
                if (filterShop.length === 0) {
                    filterShopList.push(shop)
                }
            }

            setData['shopDataList'] = filterShopList;

            let splitDateA = this.state.From_Week.split('-');
            splitDateA[1] = splitDateA[1].replace("W", "");
            let joinArrayA = parseInt(splitDateA.join(""))

            let splitDateB = this.state.To_Week.split('-');
            splitDateB[1] = splitDateB[1].replace("W", "");
            let joinArrayB = parseInt(splitDateB.join(""))

            let weekDaysList = []
            let cardWeekDays = []
            let initialWeek = parseInt(splitDateA[0])
            for (joinArrayA; joinArrayA <= joinArrayB; joinArrayA++) {
                let element = parseInt(joinArrayA.toString().slice(-2));
                if (element > 0 && element < 52) {
                    let pushData = "";
                    if (element === 1) { initialWeek++ };
                    if (element < 10) element = '0' + element;
                    pushData = `${+initialWeek}-W${element}`;
                    let MappedValue = [+initialWeek, element].map(n => parseInt(n)).reverse();
                    let WeekOut = await getISOWeek(...MappedValue);
                    /* PnL is sized to the COLUMN list and pre-filled, because Detail.js treats
                       columns / PnL / totals as parallel arrays indexed by column (see its
                       comment). It used to be an empty array that each matching partner pushed
                       onto, so a week where only 15 of 19 shops had a live window produced 15
                       values that were then read against columns 0-14 — every figure landed on
                       the WRONG shop, and the four shops at the end silently got none. The row
                       and column totals still added up, which is why it looked plausible. */
                    weekDaysList.push({ WeekOut, weekNum: pushData, joinPnLWeekDate: parseInt(`${+initialWeek}${element}`), PnL: new Array(filterShopList.length).fill(0) });
                    cardWeekDays.push({ WeekOut, weekNum: pushData, joinPnLWeekDate: parseInt(`${+initialWeek}${element}`), PnL: [] });
                }
            }
            let settleData = [];

            for (let i = 0; i < totalFilledWeek.length; i++) {
                const PnLData = totalFilledWeek[i];
                let filterData = weekDaysList.filter(x => x.joinPnLWeekDate === PnLData.joinPnLWeekDate);
                if (filterData.length > 0) {
                    let sharedPnL = (PnLData.weeklySalePnL / 100) * PnLData.totalPerc
                    /* By SHOP, not by arrival order. String() on both sides because shop ids reach
                       the browser as an int from pc_shop and as a string everywhere else. */
                    const col = filterShopList.findIndex(
                        x => String(x?.ShopName?.value) === String(PnLData.shopID));
                    if (col >= 0) {
                        /* += so a shop with two windows both touching one week accumulates
                           rather than overwrites. */
                        filterData[0]['PnL'][col] = (+filterData[0]['PnL'][col] || 0) + sharedPnL;
                        settleData.push(filterData[0])
                    }
                }
            }

            let updatedData = [];

            for (let i = 0; i < settleData.length; i++) {
                const setData = settleData[i];
                let filter = updatedData.filter(x => x.joinPnLWeekDate === setData.joinPnLWeekDate)
                if (filter.length === 0) {
                    updatedData.push(setData)
                }
            }

            let e = []

            for (let i = 0; i < updatedData.length; i++) {
                const aa = updatedData[i];
                for (let j = 0; j < aa.PnL.length; j++) {
                    const aPnL = aa.PnL[j];
                    e.push({ j: j, aPnL: +aPnL });
                }
            }

            let updatedShopA = [];
            let totalPnL = 0;
            for (let i = 0; i < filterShopList.length; i++) {
                const shop = filterShopList[i];
                for (let j = 0; j < e.length; j++) {
                    const aeab = e[j];
                    if (i === aeab.j) {
                        if (!shop['totalValue']) {
                            shop['totalValue'] = 0
                        }
                        totalPnL += aeab.aPnL
                        shop['totalValue'] = shop['totalValue'] + aeab.aPnL
                    }
                }
                updatedShopA.push(shop)
            }

            setData['totalPnL'] = totalPnL;
            setData['weekDaysList'] = this.withUnapprovedWeekRows(updatedData, weekDaysList, shopData.unapprovedWeeks);
            setData['totalShopCash'] = updatedShopA;


            let cardShops = []
            let totalFilledCardWeek = []
            for (let i = 0; i < parsifyShopCard.length; i++) {
                const cardShop = parsifyShopCard[i];
                cardShops.push(cardShop.ShopName.label)

                for (let j = 0; j < reportDataC.length; j++) {
                    const PnLWeekList = reportDataC[j];
                    let PnLWeekDate = PnLWeekList.PC_WS_WEEK.split('-');
                    PnLWeekDate[1] = PnLWeekDate[1].replace("W", "");
                    let joinPnLWeekDate = parseInt(PnLWeekDate.join(""));
                    /* Window holds DATES since migration 2026_10_14. A week counts when its
                     * MONDAY falls inside it — helper.js weekInDateWindow(). */
                    if (weekInDateWindow(PnLWeekList.PC_WS_WEEK, cardShop.FromDate, cardShop.ToDate) && (PnLWeekList.PC_WS_SHOPID === cardShop.ShopName.value)) {
                        totalFilledCardWeek.push({ joinPnLWeekDate, weeklySalePnL: PnLWeekList.WS_Card, shopID: PnLWeekList.PC_WS_SHOPID })
                    }
                }
            }

            let settleDataA = [];

            for (let i = 0; i < totalFilledCardWeek.length; i++) {
                const PnLData = totalFilledCardWeek[i];
                let filterData = cardWeekDays.filter(x => x.joinPnLWeekDate === PnLData.joinPnLWeekDate);
                if (filterData.length > 0) {
                    filterData[0]['PnL'].push(PnLData.weeklySalePnL)
                    settleDataA.push(filterData[0])
                }
            }

            let updatedDataA = [];

            for (let i = 0; i < settleDataA.length; i++) {
                const setData = settleDataA[i];
                let filter = updatedDataA.filter(x => x.joinPnLWeekDate === setData.joinPnLWeekDate)
                if (filter.length === 0) {
                    updatedDataA.push(setData)
                }
            }

            let f = []

            for (let i = 0; i < updatedDataA.length; i++) {
                const aa = updatedDataA[i];
                for (let j = 0; j < aa.PnL.length; j++) {
                    const aPnL = aa.PnL[j];
                    f.push({ j: j, aPnL: +aPnL });
                }
            }

            let updatedShopAA = [];

            for (let i = 0; i < parsifyShopCard.length; i++) {
                const shop = parsifyShopCard[i];
                for (let j = 0; j < f.length; j++) {
                    const aeab = f[j];
                    if (i === aeab.j) {
                        if (!shop['totalValue']) {
                            shop['totalValue'] = 0
                        }
                        shop['totalValue'] = shop['totalValue'] + aeab.aPnL
                    }
                }
                updatedShopAA.push(shop)
            }

            let totalCardSum = sumMoney(updatedShopAA, "totalValue");

            setData['cardShops'] = cardShops;
            setData['cardWeekList'] = cardShops.length > 0
                ? this.withUnapprovedWeekRows(updatedDataA, cardWeekDays, shopData.unapprovedWeeks)
                : updatedDataA;
            setData['cardTotal'] = updatedShopAA;
            setData['totalCardSum'] = totalCardSum;

            // reportDataC
            let payByAccountList = [];
            let pbaTotal = 0

            for (let i = 0; i < reportDataB.length; i++) {
                const element = reportDataB[i];

                let parsifyJSON = JSON.parse(element.AP_WEEK_DAYS)
                let parsifyJSONData = JSON.parse(element.AP_DETAILS)
                let fillAccData = [];
                for (let j = 0; j < parsifyJSONData.length; j++) {
                    const subEle = parsifyJSONData[j];
                    // Keep a line when EITHER selector holds an entity: shop-only lines put the
                    // shop in ShopPay_Acc and leave ShopPay_Shop "". Padding rows have neither.
                    if (isAccPayLine(subEle)) {
                        fillAccData.push(subEle)
                    }
                }
                pbaTotal += sumMoney(fillAccData, "ShopPay_Amnt");

                payByAccountList.push({
                    AP_WEEK_DAYS: `${parsifyJSON[0]['DateAndDay']} - ${parsifyJSON[6]['DateAndDay']}`,
                    AP_WEEK: element.AP_WEEK,
                    AP_DETAILS: fillAccData
                })
            }

            setData['pbaTotal'] = round2(pbaTotal);
            setData['payByAccountList'] = payByAccountList;

            let pbsTotal = 0
            let a = [...reportDataF, ...reportDataE, ...reportDataH];
            let payByShop = []
            console.log(a, 'a')
            for (let i = 0; i < a.length; i++) {
                const rowData = a[i];
                let filterByWeek = payByShop.filter(x => x.TR_WEEK === rowData.TR_WEEK);

                if (filterByWeek.length === 0) {
                    let weekYearArr = rowData.TR_WEEK.split("-");
                    weekYearArr[1] = weekYearArr[1].replace("W", "");
                    let MappedValue = weekYearArr.map(n => parseInt(n)).reverse();
                    let WeekOut = await getISOWeek(...MappedValue);
                    payByShop.push({
                        SP_WEEK_DAYS: `${WeekOut[0]} - ${WeekOut[6]}`,
                        TR_WEEK: rowData.TR_WEEK,
                        SP_DETAILS: []
                    })
                }

                for (let j = 0; j < payByShop.length; j++) {
                    const pbs = payByShop[j];
                    if (pbs.TR_WEEK === rowData.TR_WEEK) {
                        pbs.SP_DETAILS.push(rowData)
                    }
                }
            }

            pbsTotal = sumMoney(a, "TR_AMT");

            setData['pbsTotal'] = pbsTotal;
            setData['payByShopList'] = payByShop;

        }

        if (shopPreData.success === 1 && shopPreData.message === "Record Available.") {
            let reportPreDataB = shopPreData.dataB;
            let reportPreDataC = shopPreData.dataC;
            let reportPreDataE = shopPreData.dataE;
            let reportPreDataF = shopPreData.dataF;
            let reportPreDataH = shopPreData.dataH;

            /* No column list or week list is built here any more. The brought-forward figures
               are period TOTALS, summed directly from the rows below; the per-week, per-column
               arrays this block used to build were never rendered, and bucketing prior weeks
               against the in-range week list is what produced the faults fixed on 2026-10-21. */
            /* BROUGHT-FORWARD P&L SHARE — rewritten 2026-10-21, because every prior share was
             * counted many times over.
             *
             * The old code routed each prior (shop, week) share into
             * `weekDaysList.filter(x => x.joinPnLWeekDate > ...)[0]` — always the FIRST in-range
             * week — and then "de-duplicated" that list with the same `>` test. Two entries
             * holding the same week can never satisfy `>`, so nothing was ever removed: the one
             * accumulated week object was pushed once per prior row and then summed once per
             * copy. Ashraf's 20 prior rows multiplied the share by 20 (6,796.10 -> 135,922.01);
             * Taimoor's 72 rows by 72. Every account with prior activity was affected.
             *
             * The totals are the only thing BALANCE B/F needs, and the per-column array built
             * here was never rendered — Detail.js reads `totalValue` (in-range) and `FB` — so the
             * array machinery is gone with the bug.
             *
             * There is deliberately no `col >= 0` test. A partnership that has since ended still
             * earned its share at the time, and skipping it would leave that money out of the
             * opening position; it simply gets no column, because it is not in this window. On
             * today's data every prior shop still has a column, so this changes no figure now.
             */
            let totalPnLPre = 0;
            for (let i = 0; i < totalPreFilledWeek.length; i++) {
                const PnLData = totalPreFilledWeek[i];
                totalPnLPre += (PnLData.weeklySalePnL / 100) * PnLData.totalPerc;
            }

            /* BROUGHT-FORWARD CARD TAKINGS — rewritten 2026-10-21.
             *
             * NET BALANCE subtracts the card takings of the weeks on screen, but FB below never
             * subtracted the card takings of the weeks BEFORE them, so the balance carried
             * forward was always too high by that amount — on its own, 9,392.00 for Ashraf,
             * 56,748.88 for Khadim, 147,223.88 across all accounts for a single month. That is
             * why September's BALANCE B/F could not equal August's NET BALANCE.
             *
             * It is summed straight from the rows here. The machinery this replaces could never
             * have produced a figure anyway: it bucketed prior weeks against `cardWeekDays`,
             * which only holds the IN-RANGE weeks, with `===`, so nothing ever matched and the
             * result was an empty list it then summed to nothing.
             */
            let totalCardSumPre = 0
            for (let i = 0; i < parsifyShopCard.length; i++) {
                const cardShop = parsifyShopCard[i];
                for (let j = 0; j < reportPreDataC.length; j++) {
                    const PnLWeekList = reportPreDataC[j];
                    /* Window holds DATES since migration 2026_10_14. A week counts when its
                     * MONDAY falls inside it — helper.js weekInDateWindow(). */
                    if (weekInDateWindow(PnLWeekList.PC_WS_WEEK, cardShop.FromDate, cardShop.ToDate) && (PnLWeekList.PC_WS_SHOPID === cardShop.ShopName.value)) {
                        totalCardSumPre += +PnLWeekList.WS_Card;
                    }
                }
            }

            // reportPreDataC
            let payByAccountList = [];
            let pbaTotal = 0

            for (let i = 0; i < reportPreDataB.length; i++) {
                const element = reportPreDataB[i];

                let parsifyJSON = JSON.parse(element.AP_WEEK_DAYS)
                let parsifyJSONData = JSON.parse(element.AP_DETAILS)
                let fillAccData = [];
                for (let j = 0; j < parsifyJSONData.length; j++) {
                    const subEle = parsifyJSONData[j];
                    // Same rule as the in-range block, so the brought-forward FB stays consistent.
                    if (isAccPayLine(subEle)) {
                        fillAccData.push(subEle)
                    }
                }
                pbaTotal += sumMoney(fillAccData, "ShopPay_Amnt");

                payByAccountList.push({
                    AP_WEEK_DAYS: `${parsifyJSON[0]['DateAndDay']} - ${parsifyJSON[6]['DateAndDay']}`,
                    AP_WEEK: element.AP_WEEK,
                    AP_DETAILS: fillAccData
                })
            }

            let pbsTotal = 0
            let a = [...reportPreDataF, ...reportPreDataE, ...reportPreDataH];

            let payByShop = []
            for (let i = 0; i < a.length; i++) {
                const rowData = a[i];
                let filterByWeek = payByShop.filter(x => x.TR_WEEK === rowData.TR_WEEK);

                if (filterByWeek.length === 0) {
                    let weekYearArr = rowData.TR_WEEK.split("-");
                    weekYearArr[1] = weekYearArr[1].replace("W", "");
                    let MappedValue = weekYearArr.map(n => parseInt(n)).reverse();
                    let WeekOut = await getISOWeek(...MappedValue);
                    payByShop.push({
                        SP_WEEK_DAYS: `${WeekOut[0]} - ${WeekOut[6]}`,
                        TR_WEEK: rowData.TR_WEEK,
                        SP_DETAILS: []
                    })
                }

                for (let j = 0; j < payByShop.length; j++) {
                    const pbs = payByShop[j];
                    if (pbs.TR_WEEK === rowData.TR_WEEK) {
                        pbs.SP_DETAILS.push(rowData)
                    }
                }

            }

            pbsTotal = sumMoney(a, "TR_AMT");

            /* BALANCE B/F is the account's position the instant before the first week on screen,
             * so it must be the NET BALANCE of everything before it — the same five terms NET
             * uses (Detail.js footer): opening balance, P&L share and account payments in, card
             * takings and shop payments out. `totalCardSumPre` is the term that was missing. */
            setData['FB'] = parseFloat((+totalPnLPre + +pbaTotal + +openBalance) - +totalCardSumPre - +pbsTotal).toFixed(2)
        }


        return setData;

    }

    render() {
        let { shopPaymentDays } = this.state;
        return (
            <Container>
                <PageHeader breadcrumb="section" title="Account Balances"
                    right={<PrintButton content={() => this.newRef} disabled={this.state.showReport !== true} />} />
                <FilterCard>
                    <Row>
                        <Col style={{ textAlign: "center" }} >
                            <FormControl>
                                <RadioGroup
                                    row
                                    aria-labelledby="reportView-label"
                                    name="reportView"
                                    value={this.state.reportView}
                                    sx={{ '& .MuiSvgIcon-root': { fontSize: 14 } }}
                                >
                                    <FormControlLabel value="detail" control={<Radio />} label="Detail" onChange={this.handleChange.bind(this, 'reportView')} />
                                    <FormControlLabel value="summary" control={<Radio />} label="Summary" onChange={this.handleChange.bind(this, 'reportView')} />
                                </RadioGroup>
                            </FormControl>
    
    
                        </Col>
                    </Row>
                    <Row style={{ alignItems: 'center' }} >
                        <Col md={3} >
                            <Form.Group className="mb-3" >
                                <Form.Label>Account</Form.Label>
                                <Select menuPortalTarget={document.body}
                                    name="Account_Name"
                                    menuPlacement="auto"
                                    isClearable={true}
                                    style={{ height: '32px' }}
                                    isDisabled={this.state.isAccountDisable || this.state.reportView === 'summary'}
                                    value={this.state.Account_Name}
                                    options={this.state.AccountList}
                                    onChange={this.handleChange.bind(this, 'Account_Name')}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={3} >
                            <Form.Group className="mb-3" >
                                <Form.Label
                                    style={{
                                        width: '100%',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: '8px',
                                        /*
                                         * The date range on the right is EMPTY until a week is picked.
                                         * Without nowrap and a reserved line height it appeared on
                                         * selection, wrapped to a second line, and shoved the picker
                                         * down — the whole filter row visibly jumped the moment you
                                         * chose a week. Reserve the line, never wrap, truncate instead.
                                         */
                                        whiteSpace: 'nowrap',
                                        minHeight: '24px',
                                        overflow: 'hidden'
                                    }}
                                >
                                    <span style={{ flexShrink: 0 }}>From Week</span>
                                    <span
                                        style={{
                                            flexShrink: 1,
                                            minWidth: 0,
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            fontWeight: 400,
                                            opacity: 0.75
                                        }}
                                    >{shopPaymentDays.length > 0 ? `(${shopPaymentDays[0]['DateAndDay']} - ${shopPaymentDays[6]['DateAndDay']})` : ``}</span>
                                </Form.Label>
                                <WeekRangeSelect
                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    value={this.state.From_Week}
                                    onChange={this.handleChange.bind(this, "From_Week")}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={3} >
                            <Form.Group className="mb-3" >
                                <Form.Label
                                    style={{
                                        width: '100%',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'baseline',
                                        gap: '8px',
                                        /*
                                         * The date range on the right is EMPTY until a week is picked.
                                         * Without nowrap and a reserved line height it appeared on
                                         * selection, wrapped to a second line, and shoved the picker
                                         * down — the whole filter row visibly jumped the moment you
                                         * chose a week. Reserve the line, never wrap, truncate instead.
                                         */
                                        whiteSpace: 'nowrap',
                                        minHeight: '24px',
                                        overflow: 'hidden'
                                    }}
                                >
                                    <span style={{ flexShrink: 0 }}>To Week</span>
                                    <span
                                        style={{
                                            flexShrink: 1,
                                            minWidth: 0,
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            fontWeight: 400,
                                            opacity: 0.75
                                        }}
                                    >{shopPaymentDays.length > 0 ? `(${shopPaymentDays[0]['DateAndDay']} - ${shopPaymentDays[6]['DateAndDay']})` : ``}</span>
                                </Form.Label>
                                <WeekRangeSelect
                                    menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    value={this.state.To_Week}
                                    onChange={this.handleChange.bind(this, "To_Week")}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Button className="add-button" size="small" variant="contained" onClick={this.handleViewReport.bind(this)} >View</Button>
                        </Col>
                    </Row>
                </FilterCard>
                {this.state.reportView === 'detail' && this.state.showReport === true ?
                    <Detail ref={el => (this.newRef = el)} ReportDetails={this.state.ReportDetails} />
                    :
                    ""
                }
                {this.state.reportView === 'summary' && this.state.summaryBusy === true ?
                    <div style={{ textAlign: 'center', padding: '18px', fontSize: '14px' }} >
                        Building summary — {this.state.summaryDone} of {this.state.summaryTotal} accounts…
                    </div>
                    :
                    ""
                }

                {this.state.reportView === 'summary' && this.state.showReport === true && this.state.summaryBusy === false ?
                    <Summary
                        ref={el => (this.newRef = el)}
                        TotalSummary={this.state.TotalSummary}
                        UnapprovedWeeks={this.state.summaryUnapproved}
                        WeekRange={formatDisplayWeek(this.state.From_Week) === formatDisplayWeek(this.state.To_Week)
                            ? formatDisplayWeek(this.state.From_Week)
                            : `${formatDisplayWeek(this.state.From_Week)}  |  ${formatDisplayWeek(this.state.To_Week)}`}
                    />
                    :
                    ""
                }

            </Container>
        );
    }
}

export default AccountBalance;